export { default } from './TreeInfoCategories.vue'
